export type PersonalizationFirstPersonStatus = 'COMPLETE' | 'INCOMPLETE' | 'NOT_SET';
